/**
 * Map configuration constants
 */

/**
 * Debounce period for marker clicks to prevent map click from
 * immediately clearing selection after a marker is clicked.
 */
export const MARKER_CLICK_DEBOUNCE_MS = 250;

/**
 * Default map zoom level - matches 25km default radius.
 * Tuned for ~60° latitude (Norway region).
 */
export const DEFAULT_MAP_ZOOM = 11;

/**
 * Maps search radius (km) to appropriate Google Maps zoom level.
 * These values are tuned for ~60° latitude (Norway region).
 * Higher zoom = more zoomed in (smaller area visible).
 *
 * Note: Zoom levels vary by latitude because Google Maps uses Mercator projection.
 * At higher latitudes, 1° longitude covers less distance. These values are
 * optimized for the Oslo/Norway area where this application operates.
 */
export const RADIUS_TO_ZOOM: Record<number, number> = {
  5: 13,
  10: 12,
  25: 11,
  50: 10,
  100: 9,
};

/**
 * Static map placeholder dimensions.
 * Using scale=2 gives 1280x1280 actual pixels for retina displays.
 * Dimensions comply with Google Static Maps API limits (640x640 max with scale=2).
 * CSS object-fit: cover handles different container sizes.
 */
export const STATIC_MAP_WIDTH = 640;
export const STATIC_MAP_HEIGHT = 640;
